import React from "react";
const CreateButton: React.FC = () => (
  <div className="create-button d-flex justify-content-end">
    {" "}
    <button className="btn btn-primary">Create</button>
  </div>
);
export default CreateButton;
